import { createFileRoute, Outlet } from "@tanstack/react-router";
import SuperLayoutTitle from "@/components/layout/super-layout/super-layout-title";
import PageNavigationTabs from "@/components/navigation/page-navigation-tabs";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import { Id } from "@/convex/_generated/dataModel";

export const Route = createFileRoute("/_super/super/control-panel/$companyId")({
  component: ControlPanelLayout,
});

function ControlPanelLayout() {
  const { companyId } = Route.useParams();

  const details = useQuery(
    api.companies.subscriptions.queries.getCompanySubscriptionDetails,
    {
      companyId: companyId as Id<"companies">,
    },
  );

  const tabs = [
    {
      name: "Vista General",
      href: `/super/control-panel/${companyId}/overview`,
      icon: "LayoutDashboard",
      description: "Información general de la empresa",
    },
    {
      name: "Suscripción",
      href: `/super/control-panel/${companyId}/subscription`,
      icon: "CreditCard",
      description: "Gestión de plan y suscripción",
    },
    {
      name: "Usuarios",
      href: `/super/control-panel/${companyId}/users`,
      icon: "Users",
      description: "Gestión de usuarios de la empresa",
    },
    {
      name: "Uso",
      href: `/super/control-panel/${companyId}/usage`,
      icon: "BarChart3",
      description: "Métricas y uso de recursos",
    },
    {
      name: "Historial",
      href: `/super/control-panel/${companyId}/history`,
      icon: "History",
      description: "Historial de cambios y actividad",
    },
  ];

  const companyName = details?.company?.name || "Cargando...";

  return (
    <>
      <SuperLayoutTitle title={`Panel de Control - ${companyName}`} />
      <div className="space-y-6">
        <PageNavigationTabs
          tabs={tabs}
          variant="simple-underline"
          size="default"
          showIcons={true}
          alignment="left"
        />
        <Outlet />
      </div>
    </>
  );
}
